import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { Box, Collapse, IconButton, Tooltip, Typography } from '@mui/material'
import React, { useState } from 'react'

const FunctionList = ({ fns, copyVariable }) => {
  const [openExamples, setOpenExamples] = useState({})

  const toggleExample = (name, e) => {
    e.stopPropagation()

    setOpenExamples((prev) => ({
      ...prev,
      [name]: !prev[name],
    }))
  }

  return (
    <Box
      sx={{
        border: '1px solid #eee',
        borderRadius: 2,
        maxHeight: 320,
        overflow: 'auto',
      }}
    >
      {fns.map((item) => (
        <Box
          key={item.name}
          sx={{
            borderBottom: '1px solid #f0f0f0',
          }}
        >
          <Box
            px={2}
            py={1}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            onClick={() => copyVariable(item.name)}
            sx={{
              cursor: 'pointer',
            }}
          >
            <Typography fontSize={13}>{item.name}</Typography>

            <Box display="flex" alignItems="center" gap={0.5}>
              <Tooltip title={openExamples[item.name] ? 'Hide Example' : 'View Example'}>
                <IconButton size="small" onClick={(e) => toggleExample(item.name, e)}>
                  {openExamples[item.name] ? (
                    <ExpandLessIcon fontSize="small" />
                  ) : (
                    <ExpandMoreIcon fontSize="small" />
                  )}
                </IconButton>
              </Tooltip>

              <Tooltip title="Copy">
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation()
                    copyVariable(item.name)
                  }}
                >
                  <ContentCopyIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>

          <Collapse in={openExamples[item.name]}>
            <Box
              px={2}
              pb={1.5}
              pt={0.5}
              sx={{
                backgroundColor: '#fafafa',
                borderTop: '1px solid #f3f3f3',
              }}
            >
              <Typography
                fontSize={12}
                sx={{
                  whiteSpace: 'pre-wrap',
                  fontFamily: 'monospace',
                  color: '#555',
                }}
              >
                {item.example}
              </Typography>
            </Box>
          </Collapse>
        </Box>
      ))}
    </Box>
  )
}

export default FunctionList
